import React from "react"
import {FormattedMessage} from "react-intl"

export default {
	load() {
		return {
			fields: {
				agreement_part_number: {
					label: <FormattedMessage id="Agreement.Container.Detail.PartNumber" />,
					rules: "required"
				},
				from: {
					label: <FormattedMessage id="Agreement.Container.Detail.From" />,
					type: "date",
					rules: "required"
				},
				to: {
					label: <FormattedMessage id="Agreement.Container.Detail.To" />,
					type: "date"
				},
				sufficient: {
					label: <FormattedMessage id="Agreement.Container.Detail.Sufficient" />,
					type: "checkbox",
					value: true
				},
				subject_matter: {
					label: <FormattedMessage id="Agreement.Container.Detail.PartSubjectMatter" />
				}
			}
		}
	}
}
